<template>
	<v-main class="core-main">
		<div id="core-view">
			<v-fade-transition mode="out-in">
				<nuxt />
			</v-fade-transition>
		</div>
	</v-main>
</template>

<script>
export default {};
</script>

<style>
.core-main {
	background-color: #f7f8fa !important;
}

.core-main > .v-main__wrap {
	background-color: #f7f8fa !important;
}

#core-view {
	padding-bottom: 100px;
	margin: 15px 20px;
	min-height: calc(100vh - 100px);
}
</style>
